import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private cookieService: CookieService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  /**
   * Save token in localStorage
   * @param token token information
   */
  public setToken(token): void {
    localStorage.setItem('token', token);
  }

  /**
   * Save token in cokies
   * @param data token information
   */
  public setTokenCokie(data): void {
    const results = {
      user: {
        id: data.id,
        name: data.name,
        code: data.code,
        Permissions: data.Permissions,
        profile: data.profile,
      },
      token: data.token,
    };
    const baseDomain = 'localhost';
    const expireAfter = new Date();
    expireAfter.setDate(expireAfter.getDate() + 1);
    // setup cookie
    this.cookieService.set(
      'data',
      JSON.stringify(results),
      expireAfter,
      '/',
      baseDomain
    );
  }

  /**
   * Determine if current user is active
   */
  public getTokenCokie() {
    if (this.cookieService.get('data')) {
      const user = JSON.parse(this.cookieService.get('data'));
      return user;
    }
    this.goToLogin();
  }

  goToLogin(): void {
    this.document.location.href = environment.URL_LOGIN;
  }

  goToApp(): void {
    this.document.location.href = environment.URL_LOGIN + 'apps/select-app';
  }

  updateAvatar(avatar) {
    const user = JSON.parse(this.cookieService.get('data'));
    user.user.avatar = avatar;
    const baseDomain = environment.URL_DOMAIN;
    const expireAfter = new Date();
    expireAfter.setDate(expireAfter.getDate() + 1);
    // setup cookie
    this.cookieService.set(
      'data',
      JSON.stringify(user),
      expireAfter,
      '/',
      baseDomain
    );
  }

  /**
   * Retrun token of localStorage
   */
  public getToken() {
    return localStorage.getItem('token');
  }

  /**
   * Check if there is an session
   */
  public isLoggedIn(data): boolean {
    if (Object.keys(data).length > 0) {
      const arrayCond = [];
      const storedPermissions = JSON.parse(localStorage.getItem('permissions'));
      data.roles.map((element) => {
        arrayCond.push(storedPermissions.includes(element));
      });
      return arrayCond.includes(true);
    }
    return true;
  }

  /**
   * End the current user's session
   */
  public logout(): void {
    const baseDomain = environment.URL_DOMAIN;
    this.cookieService.deleteAll('/', baseDomain);
    localStorage.clear();
    this.goToLogin();
  }
  /**
   * Check if user is Account Manager
   * Special case for redirect
   */
  public isAccountManager(): boolean {
    const storedPermissions = JSON.parse(localStorage.getItem('permissions'));
    return storedPermissions.includes('Account Manager');
  }

  updateCustomer(customer) {
    const user = JSON.parse(this.cookieService.get('data'));
    user.customer = customer;
    user.user.logo = customer.logo;
    const baseDomain = environment.URL_DOMAIN;
    const expireAfter = new Date();
    expireAfter.setDate(expireAfter.getDate() + 1);
    // setup cookie
    this.cookieService.set(
      'data',
      JSON.stringify(user),
      expireAfter,
      '/',
      baseDomain
    );
  }
}
